import Index from '../../views/main/events/Index'
import Create from '../../views/main/events/Create'
import Edit from '../../views/main/events/Edit';

export default [
  {
    component: Index,
    name: 'events-index',
    path: '/events',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'events',
    }
  },
  {
    component: Create,
    name: 'events-create',
    path: '/events/create',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'events',
    }
  },
  {
    component: Edit,
    name: 'events-edit',
    path: '/events/edit/:id',
    meta: {
      layout: 'main-layout',
      requiresAuth: true,
      module: 'events',
    }
  },
]
